import { createRouter, createWebHashHistory } from "vue-router";
import UserNotice from "../views/user/Notice.vue";
import UserForm from "../views/user/Form.vue";
import AdminLogin from "../views/admin/Login.vue";
import AdminList from "../views/admin/List.vue";

const routes = [
  {
    path: "/",
    redirect: "/notice",
  },
  {
    path: "/notice",
    name: "Notice",
    component: UserNotice,
  },
  {
    path: "/form",
    name: "Form",
    component: UserForm,
  },
  {
    path: "/admin/login",
    name: "AdminLogin",
    component: AdminLogin,
  },
  {
    path: "/admin/list",
    name: "AdminList",
    component: AdminList,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("adminToken");
    if (token) {
      next();
    } else {
      next("/admin/login");
    }
  } else {
    next();
  }
});

export default router;
